// these should match the breakpoints from the _global_variables.scss file.

import { breakpointsTokens } from '../../tokens/globals/tokens';

export const MOBILE_WIDTH = breakpointsTokens.GlobalMobile;
export const TABLET_PORTRAIT_WIDTH = breakpointsTokens.GlobalTabletPortrait;
export const TABLET_LANDSCAPE_WIDTH = breakpointsTokens.GlobalTabletLandscape;
export const DESKTOP_WIDTH = breakpointsTokens.GlobalDesktopNormal;
export const DESKTOP_LARGE_WIDTH = breakpointsTokens.GlobalDesktopLarge;

const breakpoints = {
  MOBILE_WIDTH,
  TABLET_PORTRAIT_WIDTH,
  TABLET_LANDSCAPE_WIDTH,
  DESKTOP_WIDTH,
  DESKTOP_LARGE_WIDTH,
} as const;

export default breakpoints;
